export const bold = 'Montserrat Bold'
export const semiBold = 'Montserrat SemiBold'
export const medium = 'Montserrat Medium'
export const regular = 'Montserrat Regular'
export const light = 'Montserrat Light'
export const lightItalic = 'Montserrat Light Italic'
